<app-feature-branch-banner></app-feature-branch-banner>
<stb-surface
  [variant]="'background'"
  [display]="'flex'"
  class="pt-subsection-away! pb-section-away! grow flex-col"
  [class.dashboard-gradient]="isDashboardPage()"
>
  <main>
    <app-menu></app-menu>
    <app-all-pages-alert class="hide-only-on-print" />

    @if (showDevPanel$ | async) {
      <app-dev class="hide-only-on-print" data-phosphor-icons="true"></app-dev>
    }

    @if (hasCriticalErrors$ | async) {
      <section class="container" data-phosphor-icons="true">
        <app-errors></app-errors>
      </section>
    } @else if (hasRoleErrors$ | async) {
      <app-role-error data-phosphor-icons="true"></app-role-error>
    } @else {
      <div class="container flex flex-col grow" data-phosphor-icons="true">
        @if (outlet.isActivated) {
          @if (showBreadcrumbs$ | async) {
            <div class="hide-only-on-print mb-24">
              <app-breadcrumbs-rebrand></app-breadcrumbs-rebrand>
            </div>
          } @else {
            <div class="my-16" id="breadcrumb-empty"></div>
          }
        } @else {
          <div class="min-h-screen">
            <stb-loading-indicator-dots
              class="absolute-spinner"
              [size]="'large'"
              [label]="' '"
              [colorVariant]="'onGrey'"
              [rebrand]="true"
            ></stb-loading-indicator-dots>
          </div>
        }

        <!--
          detectChanges() here closes a timing gap where the new page could render
          before this OnPush component notices and hides the loading spinner above,
          causing a brief flash where both are visible at once.
        -->
        <router-outlet
          id="router-outlet"
          tabindex="-1"
          #outlet="outlet"
          (activate)="cdr.detectChanges()"
        ></router-outlet>
      </div>
    }
  </main>
</stb-surface>

<app-refresh-modal data-phosphor-icons="true"></app-refresh-modal>
